import React from "react";
import { Text } from "./text";
interface TextHighlightWordsProps {
    text:string,
    style: any,
    hightlightColor?: string,
    wordsToHighlight: Array<string>,
    onPress?:any
  }

export const TextHighlightWords = (props:TextHighlightWordsProps) => {
    const words = props.text.split(' ');
    const wordsToHighlight = props.wordsToHighlight;
    let hightlightColor = props.hightlightColor;
    let key = 0;

    if(!hightlightColor){
      hightlightColor = "blue";
    }
    
    return <Text onPress={props.onPress} style={{...props.style}} >{words.map(word => {
      if (wordsToHighlight.includes(word)) {
        key++;
        return <Text key={key} style={{color:hightlightColor }}>{word} </Text>;
      }
      return `${word} `;
    })}</Text>;
}